// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const SEO_TITLE_STROLLER_SEARCH = "Podrobn\u00e9 hled\u00e1n\u00ed - Najdi sv\u016fj vysn\u011bn\u00fd ko\u010d\u00e1rek";
export const STROLLERS_COMPARISON = "Porovnej";
export const STROLLER_SEARCH_SUBMIT = "Zobraz";
export const STROLLER_SEARCH_TITLE = "Hled\u00e1n\u00ed";
export const STROLLERS_SEARCH_RESULTS_results = "Ko\u010d\u00e1rky: %(results)s ";
